import { useContext, useState, useTransition } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import {
  Avatar,
  ListItem,
  ListItemAvatar,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
} from "@mui/material";

import FolderSharedOutlinedIcon from "@mui/icons-material/FolderSharedOutlined";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";

import AppContext from "../appContext";
import { stringToHslColor } from "../tools";
import { useTranslation } from "react-i18next";

export default function ProjectItem({ project }) {
  const { t } = useTranslation();
  const { app, dispatch } = useContext(AppContext);
  const history = useHistory();
  const handleListItemClick = () => {
    dispatch({ type: "SET_PROJECT", payload: project });
    history.push(project.path);
  };
  const [hoverId, setHoverId] = useState(-1);

  return (
    <ListItem
      button
      onClick={handleListItemClick}
      sx={{ borderRadius: 1, padding: 2 }}
      selected={app.project.id === project.id}
      onMouseOver={() => setHoverId(project.id)}
      onMouseLeave={() => setHoverId(null)}
    >
      <ListItemAvatar>
        <Avatar sx={{ bgcolor: stringToHslColor(project.code) }}>
          {project.id === 0 ? (
            <FolderOutlinedIcon />
          ) : (
            <FolderSharedOutlinedIcon />
          )}
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={`${project.firstName} ${project.lastName}`}
        secondary={
          project.id === 0
            ? `${t("projects.myProject")} (@${project.code})`
            : `@${project.code}`
        }
      />
      {hoverId === project.id ? (
        <ListItemSecondaryAction
          sx={{
            visibility: hoverId === project.id ? "visible" : "",
          }}
        >
          <IconButton
            component={Link}
            to={
              project.id === 0
                ? { pathname: "/settings" }
                : {
                    pathname: "/projectSettings",
                    state: {
                      from: "projects",
                      projectId: project.id,
                    },
                  }
            }
          >
            <SettingsOutlinedIcon />
          </IconButton>
        </ListItemSecondaryAction>
      ) : null}
    </ListItem>
  );
}
